import { render, staticRenderFns } from "./orderview.vue?vue&type=template&id=33cdc0e7&scoped=true&"
import script from "./orderview.vue?vue&type=script&lang=js&"
export * from "./orderview.vue?vue&type=script&lang=js&"
import style0 from "./orderview.vue?vue&type=style&index=0&id=33cdc0e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cdc0e7",
  null
  
)

export default component.exports